







































































































































































































import { ProfileVue } from "fs-pb-vue2/vueModels/profile/ProfileVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class Profile extends ProfileVue {

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

}
